export default __webpack_public_path__ + "static/media/kangaroo2.e6736e3a.jpg";